import {usePostHog} from "~/context/PostHogContext";
import {createEffect, JSXElement} from "solid-js";
import {useMember} from "~/context/MemberContext";

export default function PostHogIdentify(): JSXElement | undefined {
    const member = useMember();
    const posthog = usePostHog();

    createEffect(() => {
        const u = member()?.user
        if (u) {
            posthog.identify(u.id, {
                email: u.email,
                name: u.firstName + " " + u.lastName,

            });
        }
    });

    return null;
}